<template lang="pug">
  div.upper-subpanel--inside
    div.col-6
      DrugInfo
    div.col-6
      MedIdInput(
        v-if="currentProgress === 'medIdInput'"
        v-on:setText="getMedId"
        :inputLabel="'輸入病歷號'"
      )

      ConfirmFlow(
        v-if="currentProgress === 'confirm'"
        :actionProgress="actionProgress"
        :confirmProgress="confirmProgress"
        v-on:confirmationFinish="getConfirmData"
        :medRecordId="medRecordId"
      )
      Loader(
        v-if="currentProgress === 'finish'"
      )

</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import DrugInfo from '../flowComp/DrugInfo';
import MedIdInput from '../flowComp/TextInput';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';


export default {
  name: 'multiflow',
  extends: MultiFlowBase,
  data() {
    return {
      stage: 'start',
      medRecordId: '',
      checkFun: undefined,
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    MedIdInput,
    Loader,
  },
  async created() {
    if (this.$store.state.schedule.currentSchedule !== null) {
      this.medRecordId = this.$store.state.schedule.currentSchedule.patient.med_record_number;
    }
    await this.$store.dispatch('fromFirstDrug');
  },
  computed: {
  },
  methods: {
    getMedId(data) {
      if (data === '' || data === undefined) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '病歷號不可以為空' });
      } else {
        this.medRecordId = data;
        this.nextProgress();
      }
    },
    getConfirmData() {
      //20190411 add by aaron
      console.log('get confirm data');
      this.nextProgress();
      //////////////////
      this.checkFun = setInterval(() => {
        this.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep() {
      //this.nextProgress(); //20190411 marked by aaron
      //console.log('get confirm data');
      if (this.nextDrug === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextDrug');
        this.resetProgress();
      }
    },
    //20190412 modified by aaron
    checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒',
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜',
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜',
          });
        } 
        else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?cb567812